export default "__VITE_ASSET__B9e14$e7__"